import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './style.css'
import { logger } from './utils/logger'
import { apiService } from './services/api'

// Global error handlers for runtime errors
window.onerror = (message, source, lineno, colno, error) => {
  logger.error('Global error:', { message, source, lineno, colno, error })
  
  // Log to backend monitoring system
  apiService.post('/admin/monitoring/log-error', {
    type: 'FRONTEND_ERROR',
    message: String(message),
    location: `${source}:${lineno}:${colno}`,
    stack: error?.stack
  }).catch(err => console.error('Failed to log error:', err))
  
  return false // Allow default error handling
}

window.onunhandledrejection = (event) => {
  const reason = event.reason

  // Detect Vite lazy-chunk 404s caused by a Vercel redeployment. When a new
  // deploy goes live, old hashed chunk URLs (e.g. PortfolioView-83441603.js)
  // are replaced. Any pending dynamic import for an old URL rejects here.
  // Guard with sessionStorage to prevent infinite reload loops.
  const isChunkError =
    reason?.message?.includes('Failed to fetch dynamically imported module') ||
    reason?.message?.includes('Importing a module script failed') ||
    reason?.message?.includes('dynamically imported module') ||
    reason?.message?.includes('Unable to preload CSS') ||
    reason?.message?.includes('error loading dynamically imported module') ||
    (reason instanceof TypeError && reason?.message?.includes('Failed to fetch'))
  if (isChunkError) {
    const lastReload = Number(sessionStorage.getItem('chunkReloadAt') || 0)
    if (Date.now() - lastReload > 10_000) {
      sessionStorage.setItem('chunkReloadAt', String(Date.now()))
      window.location.reload()
      return
    }
  }

  logger.error('Unhandled promise rejection:', reason)
  
  // Log to backend monitoring system
  apiService.post('/admin/monitoring/log-error', {
    type: 'UNHANDLED_PROMISE',
    message: String(reason),
    location: window.location.pathname,
    stack: reason?.stack
  }).catch(err => console.error('Failed to log error:', err))
}

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// WebSocket will be initialized after authentication in App.vue
// This prevents connection errors on the login page

app.mount('#app')